import type { EventEmitter } from '@stencil/core';
import { Component, Element, Event, h, Prop } from '@stencil/core';
import { Consumer } from '@sydle/ui-utils';

/**
 * @slot - Element that will consume the context.
 */
@Component({
  tag: 'sy-context-consumer',
  shadow: true,
})
export class ContextConsumer {
  private consumer: Consumer;
  private value: any;

  @Element() el: HTMLSyContextConsumerElement;

  /**
   * Context identifier
   */
  @Prop({ reflect: true }) context: string;

  /**
   * Emitted when the context value changes.
   */
  @Event() syContextDidChange: EventEmitter<any>;

  componentWillLoad() {
    this.consumer = new Consumer(this.el);
    this.consumer.subscribe(this.context, (event) => this.changeValue(event));
  }

  disconnectedCallback() {
    this.consumer.disconnect();
  }

  private changeValue(newValue: any): void {
    if (this.value !== newValue) {
      this.syContextDidChange.emit(newValue);
    }

    this.value = newValue;
  }

  render() {
    return <slot />;
  }
}
